/* Router dependencies */
import Vue from 'vue';
import VueRouter from 'vue-router';
import SecondLevelCategoryPage from '@/components/products-app-hook/second-level-category-page.vue';
import { getMountPointId } from '@/helpers/utils.js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:subcategory?',
    name: 'index',
    component: SecondLevelCategoryPage,
    props: true,
  },
  {
    path: '*',
    redirect: { name: 'index' },
  },
];

const app = document.getElementById(getMountPointId());

const router = new VueRouter({
  base: app.dataset.baseurl,
  mode: 'history',
  routes,
});

export default router;
